export default __webpack_public_path__ + "static/media/oscer-pres-leg-pain.86596e95.svg";